import { useEffect, useRef, useState } from 'react';
import { loadLevelSprite } from '../levelSprites';
import './LevelAnimalIcon.css';

const IDLE_FRAME_MS = 520;

/**
 * A level animal at icon size: drawn at its native pixel size (1×, crisp), idling
 * gently — no walk-in, no emote, no speech bubble. For small slots like the daily
 * quiz card; the full show (LevelSprite) belongs to the level sheet and the mail.
 *
 * Shows the level's emoji until the sprite chunk (a few KB) arrives.
 */
export default function LevelAnimalIcon({ level, icon }) {
  const [sprite, setSprite] = useState(null);
  const canvasRef = useRef(null);

  useEffect(() => {
    let live = true;
    setSprite(null);
    loadLevelSprite(level).then((s) => { if (live) setSprite(s); }).catch(() => {});
    return () => { live = false; };
  }, [level]);

  useEffect(() => {
    const ctx = canvasRef.current?.getContext?.('2d');
    if (!sprite || !ctx) return undefined;
    const paint = (frame) => {
      ctx.clearRect(0, 0, sprite.w, sprite.h);
      frame.forEach((row, y) => {
        for (let x = 0; x < row.length; x++) {
          const c = sprite.palette[row[x]];
          if (c) { ctx.fillStyle = c; ctx.fillRect(x, y, 1, 1); }
        }
      });
    };
    paint(sprite.idle[0]);
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return undefined;
    let i = 1;
    const timer = setInterval(() => paint(sprite.idle[i++ % sprite.idle.length]), IDLE_FRAME_MS);
    return () => clearInterval(timer);
  }, [sprite]);

  return (
    <span className="level-animal-icon" data-level={level}>
      {sprite ? (
        <canvas ref={canvasRef} width={sprite.w} height={sprite.h} />
      ) : (
        <span className="level-animal-icon-fallback">{icon}</span>
      )}
    </span>
  );
}
